module.exports = __webpack_public_path__ + "img/bg_banner_register.acc37bbe.jpg";